import type { Produto } from "@/components/vitrine/types/produto.props"
import { priceFormatter } from "@/utils/formatter"

interface ValorProdutoProps {
    produto: Produto
    precoPrincipal: number
    formasDePagamentoPaginaProduto: number
    condicaoParcelamentoProduto: number
}

export function ValorProduto({
    produto,
    precoPrincipal,
    formasDePagamentoPaginaProduto,
    condicaoParcelamentoProduto,
}: Readonly<ValorProdutoProps>) {
    const valorCartao = produto.valor_cartao
    let valorParcelado = 0
    let valorParcelas = 0
    let qtdParcelas = 1

    if (valorCartao && (formasDePagamentoPaginaProduto == 2 || formasDePagamentoPaginaProduto == 3 || formasDePagamentoPaginaProduto == 5)) {
        if (condicaoParcelamentoProduto == 1) {
            valorParcelado = produto.valor
        }  else if (condicaoParcelamentoProduto == 2 && valorCartao[5]) {
            valorParcelado = valorCartao[5]['valor']
            qtdParcelas = valorCartao[5]['parcelas']
            valorParcelas =  valorCartao[5]['valorParcela']
        } else {
            valorParcelado = valorCartao[1]
            qtdParcelas = valorCartao[0]
            valorParcelas = valorCartao[2]
        }
    }
    
    return (
        <div className="valor-produto">
            {produto.valor_de > produto.valor && (
                <div className="old-price">
                    de <span>R$ {priceFormatter.format(produto.valor_de)}</span> por
                </div>
            )}
            <span className="valor-big">
                {precoPrincipal === 2
                    ? priceFormatter.format(valorParcelado)
                    : precoPrincipal === 4
                    ? (produto.valor_pix > 0) && priceFormatter.format(produto.valor_pix)
                    : (produto.valor_boleto > 0) && priceFormatter.format(produto.valor_boleto)
                }
            </span>

            <span className="condicao-pagto">
                {precoPrincipal === 2
                    ? (valorParcelado && valorParcelado > 0) && condicaoParcelamentoProduto != 1 ? ` no cartão em ${qtdParcelas}x de ${priceFormatter.format(valorParcelas)}` :  ' à vista no cartão'
                    : precoPrincipal === 4
                    ? (produto.valor_pix > 0) && ' no pix com desconto'
                    : (produto.valor_boleto > 0) && ' no boleto com desconto'
                }
            </span>
        </div>
    )
}